import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { listPagePagination_template as pagination_template } from "~/components/templates/listPagePagination_template";
import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { vnApp_leadpilot } from "../vnApp_leadpilot";
import { renderKoDataTable, renderKoEmptyState } from "~/components/templates/listPageDataTable";
import { html, LpButton, LpFilterBar, LpPageHeader, LpTable, raw } from "~/design-system";
export class usersList_template extends vnTemplate {
    getTemplateHtml() {
        return /* html */ `
            ${LpPageHeader({
            title: "User List",
            description: "Manage user accounts, roles, and account status.",
            icon: "users",
            actions: html `
                    <!-- ko if: hasWriteAccess -->
                        ${LpButton({
                label: "Add user",
                prefixIcon: "plus",
                size: "base",
                variant: "primary",
                attributes: {
                    "data-bind": "click: onClickAdd",
                },
            })}
                    <!-- /ko -->
                `,
            controls: LpFilterBar({
                inline: false,
                controls: html `
                        <div class="users-list-filter-cell">
                            ${raw(this.filterRole.getHtmlBuild())}
                        </div>
                        <div class="users-list-filter-cell w-input users-list-active-filter">
                            <input type="checkbox" data-bind="checked: isShowActiveUsers, click: showActiveUsers" id="showActiveUser">
                            <label for="showActiveUser">Show Active Users</label>
                        </div>
                    `,
            }),
        })}

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-userRole"></div>
                </div>
            </div>

            <div class="users-list-module">
                <div class="data-module__body users-list-module__body" id="list-results">
                    ${this.getUsersTableHtml()}
                </div>
                <div class="data-module__footer users-list-module__footer">
                    <div class="users-list-module__toolbar">
                        <div class="users-list-module__meta">
                            ${this.resultInfos.getHtmlBuild()}
                        </div>
                        <div class="users-list-module__pagination">
                            ${this.pagination.getHtmlBuild()}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    getUsersTableHtml() {
        const columns = this.getUserTableColumns();
        return renderKoDataTable({
            title: "Users",
            titleIcon: "users",
            caption: "User list",
            columns,
            actions: html `<div class="users-list-module__search">${raw(this.filter.getHtmlBuild())}</div>`,
            className: "users-list-table",
            children: this.getUsersTableBodyHtml(columns),
        });
    }
    getUserTableColumns() {
        return [
            {
                key: "fullName",
                label: "Name",
                sortable: true,
                resizable: true,
                minWidth: 220,
                sortAttributes: this.getSortAttributes("fullName"),
            },
            {
                key: "loginName",
                label: "User",
                sortable: true,
                resizable: true,
                width: 180,
                minWidth: 140,
                sortAttributes: this.getSortAttributes("loginName"),
            },
            {
                key: "email",
                label: "Email",
                sortable: true,
                resizable: true,
                minWidth: 220,
                sortAttributes: this.getSortAttributes("email"),
            },
            {
                key: "dateCreation",
                label: "Created On",
                sortable: true,
                resizable: true,
                width: 160,
                minWidth: 136,
                sortAttributes: this.getSortAttributes("dateCreation"),
            },
        ];
    }
    getSortAttributes(column) {
        return {
            "data-bind": `click: onClickReorder.bind($data, '${column}'), css: { 'is-desc': orderByAndDirection()=='${column}_DESC', 'is-asc': orderByAndDirection()=='${column}_ASC' }`,
        };
    }
    getUsersTableBodyHtml(columns) {
        return html `
            ${LpTable.Body({
            attributes: {
                "data-bind": "foreach: users",
            },
            children: LpTable.Row({
                className: "cursor",
                children: html `
                        ${LpTable.Cell({
                    column: columns[0],
                    attributes: {
                        "data-bind": "click: $parent.onClickView",
                    },
                    children: html `
                                <span class="lp-table_cell-content flex td-img">
                                    <span class="w-user-img"><img class="user-img" data-bind="attr:{ src: pictureUrl }" alt=""></span>
                                    <span data-bind="text: fullName"></span>
                                </span>
                            `,
                })}
                        ${this.getUserTextCell(columns[1], "loginName")}
                        ${this.getUserTextCell(columns[2], "email")}
                        ${this.getUserTextCell(columns[3], "dateCreation")}
                    `,
            }),
        })}
            ${renderKoEmptyState({
            colSpan: columns.length,
            visibleBinding: "users().length === 0",
            title: "No users found",
            description: "No users match the current filters.",
            icon: "users",
        })}
        `;
    }
    getUserTextCell(column, binding) {
        return LpTable.Cell({
            column,
            attributes: {
                "data-bind": "click: $parent.onClickView",
            },
            children: html `<span class="lp-table_cell-content" data-bind="text: ${binding}"></span>`,
        });
    }
    /**
     * @inheritDoc
     */
    initPartial() {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.filter.setPlaceholder("Search");
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.filterRole = new multipleSelector_template("filterRole", this.getTemplateViewModel(), this.caller);
        this.filterRole.setFilterContainerClass("lib-dropdown");
        this.filterRole.setLabel("Roles");
        this.filterRole.setTagContainerId("selected-userRole");
        this.filterRole.setTagContainerCaption("Selected User Role:");
    }
    /**
     * @inheritDoc
     */
    getTemplateName() {
        return "usersList-template";
    }
    /**
     * @inheritDoc
     */
    getMainElementType() {
        return "div";
    }
    /**
     * @inheritDoc
     */
    getMainElementClasses() {
        return ["w-content"];
    }
    /**
     * @inheritDoc
     */
    buildViewModel() {
        // Define the viewmodel data/ functions.
        let huit_neuf_this = this;
        return {
            orderBy: ko.observable("fullName"),
            orderByDirection: ko.observable("ASC"),
            users: ko.observableArray([]),
            orderByAndDirection: ko.observable("fullName_ASC"),
            hasWriteAccess: ko.observable(this.caller.hasAccessToSection(vnApp_leadpilot.SECTION_ID_USER_OTHERS, vnApp_leadpilot.ACCESS_TYPE_WRITE)),
            isShowActiveUsers: ko.observable(true),
            onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            },
            onClickView: function (data, event) {
                huit_neuf_this.onClickView(data.id);
            },
            onClickAdd: function () {
                huit_neuf_this.onClickAdd();
            },
            showActiveUsers: function (data) {
                huit_neuf_this.showActiveUsers();
                return true;
            },
        };
    }
    /**
     * @inheritDoc
     */
    getViewModelForRequest() {
        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filterRole: this.getTemplateViewModel().filterRole,
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                roles: this.getTemplateViewModel().filterRole.selectedItems,
                isActive: this.getTemplateViewModel().isShowActiveUsers,
            },
        };
    }
    /**
     * Handles Reordering table.
     *
     * @param value
     * @param data
     * @param event
     */
    onClickReorder(value, data, event) {
        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            }
            else {
                data.orderByDirection("DESC");
            }
        }
        else {
            //default column sort direction
            data.orderByDirection("DESC");
        }
        data.orderByAndDirection(value + "_" + data.orderByDirection());
        this.caller.dataReorder();
    }
    /**
     * Handles the click data row event.
     *
     * @param id
     */
    onClickView(id) {
        this.caller.viewUserProfile(id);
    }
    /**
     * Handles the add user action.
     */
    onClickAdd() {
        this.caller.addUser();
    }
    /**
     * Sets users.
     *
     * @param users
     */
    setUsers(users) {
        this.getTemplateViewModel().users(users);
    }
    /**
     * Handles change to show active users checkbox.
     */
    showActiveUsers() {
        this.caller.onShowActiveUsers();
        return true;
    }
    /**
     * Sets data for the result info template.
     *
     * @param nbResults
     * @param nbPages
     * @param execTime
     */
    setResultInfo(nbResults, nbPages, execTime) {
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }
    /**
     * Sets the post types.
     *
     * @param {Array<{ id: number, name: string }>} roles
     */
    setRoles(roles) {
        this.filterRole.setItems(roles);
    }
}
